<template>
	<div>
		<modalAddress ref="modalAddress" @action="updateAddress"></modalAddress>
		<modalProfile ref="modalProfile" @action="updateProfile" :listSystem="listSystem"></modalProfile>
		<modalLoginPOS ref="modalLoginPOS" @action="ssoPOS"></modalLoginPOS>
		<modalResetPassword ref="modalResetPassword" @action="updatePassword"></modalResetPassword>
		<resetPassword ref="resetPassword" @action="updatePasswordConfirm"></resetPassword>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Pelanggan</div>
		</div>
		<v-card class="mt-3 mb-3" outlined>
			<v-list color="deep-purple lighten-5" dark class="pa-3">
				<v-list-item dense class="px-1">
					<v-spacer></v-spacer>
					<v-btn text depressed class="primary mr-2" @click="exportData">
						<v-icon>mdi-export</v-icon>
						<div class="pl-2 text-capitalize">Export</div>
					</v-btn>
					<v-btn depressed class="primary" @click="dropfilter = !dropfilter">
						<v-icon>mdi-filter</v-icon>
						<div class="pl-2">Filter</div>
					</v-btn>
				</v-list-item>
			</v-list>
		</v-card>
		<v-slide-y-transition>
			<v-card outlined class="mb-3" v-if="dropfilter">
				<filterComponent v-if="dropfilter" @searchFilter="searchFilter" @onResetFilter="onResetFilter"></filterComponent>
			</v-card>
		</v-slide-y-transition>
		<v-card outlined >
			<v-data-table loading disable-pagination :headers="headers" :items="listCustomer" :search="search" hide-default-footer :options.sync="option" :server-items-length="customerPagination.total_data" class="table-w-160">
				<template v-slot:item.action="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="" fab dark x-small depressed color="indigo" v-bind="attrs" v-on="on" @click.stop="editProfile(item.customer_network_code)">
								<v-icon dark>mdi-pencil</v-icon>
							</v-btn>
						</template>
						<span>Edit Profil</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="ml-2" fab dark color="pink" x-small depressed v-bind="attrs" v-on="on" @click.stop="editAlamat(item.customer_network_code)">
								<v-icon dark>mdi-map-marker</v-icon>
							</v-btn>
						</template>
						<span>Edit Alamat</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="ml-2" fab dark color="orange darken-2" x-small depressed v-bind="attrs" v-on="on" @click.stop="loginPOS(item.customer_network_code)">
								<v-icon dark>mdi-login-variant</v-icon>
							</v-btn>
						</template>
						<span>Login POS</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn class="ml-2" fab dark color="orange darken-2" x-small depressed v-bind="attrs" v-on="on" @click.stop="resetPassword(item.customer_network_mid)">
								<v-icon dark>mdi-lock-reset</v-icon>
							</v-btn>
						</template>
						<span>Reset Password</span>
					</v-tooltip>
				</template>
				<template v-slot:item.customer_id="{ item }">
					<div class="pt-2">{{ item.customer_id }}</div>
				</template>
				<template v-slot:item.customer="{ item }">
					<div class="pt-2">{{ item.customer_network_code }} - {{ item.customer_network_mid }}</div>
					<div class="pt-2">{{ item.customer_name }}</div>
				</template>
				<template v-slot:item.customer_is_active="{ item }">
					<v-switch v-model="item.customer_is_active" true-value="active" false-value="non_active" :disabled="isLoading" @change="editStatus(item)" :loading="isLoading"></v-switch>
				</template>
				<template v-slot:item.customer_level="{ item }">
					<div class="pt-2 text-uppercase">{{ item.customer_level }}</div>
				</template>
				<template v-slot:item.customer_order_count="{ item }">
					<div class="pt-2 text-uppercase">{{ item.customer_order_count | toNumber }}</div>
				</template>
				<template v-slot:item.customer_mobilephone="{ item }">
					<div class="pt-2">{{ item.customer_mobilephone }}</div>
					<div class="pt-2">{{ item.customer_mobilephone2 }}</div>
				</template>
        <template v-slot:item.customer_pra_mb_join_datetime="{ item }">
					<div class="pt-2">{{ item.customer_pra_mb_join_datetime | tanggaljam }}</div>
				</template>
        <template v-slot:item.customer_upgraded_datetime="{ item }">
					<div class="pt-2">{{ item.customer_upgraded_datetime | tanggaljam }}</div>
				</template>
				<template v-slot:item.customer_last_order="{ item }">
					<div class="pt-2">{{ item.customer_last_order | tanggaljam }}</div>
				</template>
				<template v-slot:item.address="{ item }">
					<div class="pt-2">{{ addressText(item) }}</div>
				</template>
				<template v-slot:item.customer_trx_method="{ item }">
					<div class="pt-2">{{ toCustomerTrxMethod(item.customer_trx_method) }}</div>
				</template>
				<template v-slot:item.customer_trx_ecommerce="{ item }">
					<div class="pt-2">{{ toCustomerEcommerce(item.customer_trx_ecommerce) }}</div>
				</template>
				<template v-slot:item.customer_ktp="{ item }">
					<div class="pt-2">{{ item.customer_ktp }}</div>
				</template>
				<template v-slot:progress>
					<div>
					</div>
				</template>
				<template v-slot:loading>
					<div class="py-3" v-if="!customerPagination">
						<loading-data></loading-data>
					</div>
					<div class="py-3" v-else>
						<not-found></not-found>
					</div>
				</template>
			</v-data-table>
		</v-card>
		<div class="pt-5" v-if="customerPagination">
			<v-row>
				<v-col cols="11" md="11" class="py-0 d-flex justify-space-between">
					<span>Total {{customerPagination.total_data | toNumber}} Data</span>
					<v-pagination v-model="page" :length="customerPagination.total_page" @input="changePage" total-visible="7" circle class="d-flex justify-end"></v-pagination>
				</v-col>
				<v-col cols="1" md="1" class="py-0 pl-0">
					<v-autocomplete :items="listLimit" v-model="limit" @input="changeLimit" hide-details class="mt-0" label="Item"></v-autocomplete>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import modalAddress from '@/views/MLwarehouse/customer/ModalAddressCustomer'
import modalProfile from '@/views/MLwarehouse/customer/ModalProfileCustomer'
import modalLoginPOS from '@/views/MLwarehouse/customer/ModalLoginPOS'
import modalResetPassword from '@/views/MLwarehouse/customer/ModalResetPassword'
import resetPassword from '@/views/MLwarehouse/customer/ResetPassword'
import filterComponent from '@/components/Filter'

const list_level = ['mb', 'pramb'];

const list_system = [{
	value: 'not_selected',
	text: 'Belum Terpilih'
}, {
	value: 'manual',
	text: 'Tanpa Sistem'
}, {
	value: 'system',
	text: 'Melalui Sistem'
}];

const list_status = [{
	value: 'active',
	text: 'Aktif'
}, {
	value: 'non_active',
	text: 'Tidak Aktif'
}];

const list_ecommerce = [{
	value: 'allowed',
	text: 'Ya'
}, {
	value: 'unallowed',
	text: 'Tidak'
}];

const allProvince = {
	province: 'Semua Provinsi',
	province_id: ''
}

const allCity = {
	city_name: 'Semua Kab/Kota',
	city_id: '',
	type: 'Kota'
}

const allSubdistrict = {
	subdistrict_name: 'Semua Kecamatan',
	subdistrict_id: ''
}

export default {
	inject: ['theme'],
	components: {
		modalAddress, modalProfile, modalLoginPOS, modalResetPassword, resetPassword, filterComponent
	},
	data() {
		return {
			sortBy: 'customer_network_id',
			sortDir: 'DESC',
			page: 1,
			limit: "10",
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			search: '',
			headers: [
			{ text: 'Aksi', value: 'action', align: 'left', width: '11%', sortable: false },
			{ text: 'Status', value: 'customer_is_active', width: '5%'},
			{ text: 'Kode Pelanggan - Kode Mitra', align: 'start', value: 'customer', width: '12%'},
			// { text: 'Kode Mitra', align: 'start', value: 'customer_network_mid'},
			// { text: 'Nama Pelanggan', value: 'customer_name'},
			{ text: 'Tipe', value: 'customer_level'},
			{ text: 'Metode', value: 'customer_trx_method', sortable: true, width: '7%' },
			{ text: 'Transaksi', value: 'customer_order_count', sortable: true, width: '7%' },
			{ text: 'E-Commerce', value: 'customer_trx_ecommerce', sortable: true, width: '7%' },
			{ text: 'Nomor Handphone', value: 'customer_mobilephone', sortable: false },
			{ text: 'KTP', value: 'customer_ktp', sortable: false },
			{ text: 'Join Pra MB', value: 'customer_pra_mb_join_datetime', width: '12%' },
			{ text: 'Upgrade MB', value: 'customer_upgraded_datetime', width: '12%' },
			{ text: 'Transaksi Terakhir', value: 'customer_last_order', width: '12%' },
			{ text: 'Alamat', value: 'address', sortable: false },
			],
			listSystem: [{
				value: 'not_selected',
				text: 'Belum Terpilih'
			}, {
				value: 'manual',
				text: 'Tanpa Sistem'
			}, {
				value: 'system',
				text: 'Melalui Sistem'
			}],
			listStatus: [{
				value: 'active',
				text: 'Aktif'
			}, {
				value: 'non_active',
				text: 'Tidak Aktif'
			}],
			params:[],
			isLoading: false,
			filterData: [{
				type: 'text',
				label: 'Kode Pelanggan',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_network_code'
				}
			}, {
				type: 'text',
				label: 'Kode Mitra',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_network_mid'
				}
			}, {
				type: 'text',
				label: 'Nama Pelanggan',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'customer_name'
				}
			}, {
				type: 'selection',
				label: 'Tipe Pelanggan',
				item: list_level,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_level'
				}
			}, {
				type: 'number',
				label: 'Nomor Telepon',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'customer_mobilephone'
				}
			}, {
				type: 'selection',
				label: 'Metode Transaksi',
				item: list_system,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_trx_method'
				}
			}, {
				type: 'selection',
				label: 'Provinsi',
				itemValue: 'province_id',
				itemText: 'province',
				item: [allProvince],
				function: this.selectProvince,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_province_id'
				}
			}, {
				type: 'selection',
				label: 'Kota',
				itemValue: 'city_id',
				itemText: 'city_name',
				item: [allCity],
				function: this.selectCity,
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_city_id'
				}
			}, {
				type: 'selection',
				label: 'Kecamatan',
				itemValue: 'subdistrict_id',
				itemText: 'subdistrict_name',
				item: [allSubdistrict],
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_subdistrict_id'
				}
			}, {
				type: 'text',
				label: 'Alamat Pelanggan',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'customer_address'
				}
			}, {
				type: 'selection',
				label: 'Status',
				item: list_status,
				itemValue: 'value',
				itemText: 'text',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_is_active'
				}
			}, {
				type: 'selection',
				label: 'Penjualan E-Commerce',
				item: list_ecommerce,
				itemValue: 'value',
				itemText: 'text',
				filter: {
					value: '',
					comparison: '=',
					type: 'string',
					field: 'customer_trx_ecommerce'
				}
			}, {
				type: 'text',
				label: 'KTP',
				filter: {
					value: '',
					comparison: 'like',
					type: 'string',
					field: 'customer_ktp'
				}
			}
			],
		}
	},
	props: {
		desserts: Array,
	},
	computed: {
		...mapState(['filterParams']),
		...mapState('customerList', ['listCustomer', 'customerPagination', 'detailCustomer']),
	},
	methods: {
		...mapActions('customerList', ['getCustomer', 'getCustomerDetail', 'getOptionProvince', 'getOptionCity', 'getOptionSubdistrict', 'updateCustomer', 'loginSsoPOS', 'exportCustomer', 'updateStatus', 'updatePasswordCustomer']),
		...mapMutations(['setFilter']),
		...mapMutations('customerList', ['clearDataCustomer']),
		...mapActions('maps', ['getMaps']),
		...mapMutations('maps', ['setLocation']),

		async editStatus(item) {
			this.isLoading = await true
			let status = await item.customer_is_active == 'active' ? 'active' : 'non_active'
			await this.updateStatus({
				network_mid: item.customer_network_mid,
				status: status
			})
			this.getData()
			this.isLoading = await false
		},
		getData() {
			this.getCustomer(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		toCustomerTrxMethod(val) {
			let methods = {
				'not_selected': '-',
				'manual': 'Non Sistem',
				'system': 'Sistem',
			}

			return methods[val]
		},
		toCustomerEcommerce(val) {
			let methods = {
				'allowed': 'Ya',
				'unallowed': 'Tidak',
			}

			return methods[val]
		},
		addressText(customer_data) {
			var data = []
			if (customer_data) {
				if (customer_data.customer_address)
					data.push(customer_data.customer_address)
				if (customer_data.customer_subdistrict_name)
					data.push(customer_data.customer_subdistrict_name)
				if (customer_data.customer_city_name)
					data.push(customer_data.customer_city_name)
				if (customer_data.customer_province_name)
					data.push(customer_data.customer_province_name)
			}
			return data.join(', ')
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		async editProfile(network_code) {
			await this.getCustomerDetail(network_code)
			await this.$refs.modalProfile.showModal(this.detailCustomer)
		},
		async editAlamat(network_code) {
			await this.getCustomerDetail(network_code)
			if (this.detailCustomer.customer_latitude || this.detailCustomer.customer_latitude) {
				await this.setLocation({
					lat: parseFloat(this.detailCustomer.customer_latitude),
					lng: parseFloat(this.detailCustomer.customer_longitude)
				})
			} else {
				await this.getMaps((this.detailCustomer.customer_address ? this.detailCustomer.customer_address + ', ' : '') + this.detailCustomer.customer_subdistrict_name + ', ' + this.detailCustomer.customer_city_name + ', ' + this.detailCustomer.customer_province_name)
			}
			await this.$refs.modalAddress.showModal(this.detailCustomer)
		},
		async updateAddress(params) {
			await this.updateCustomer(params).then(() => {
				this.getData()
				this.$refs.modalAddress.hideModal()
			})
		},
		async updateProfile(params) {
			await this.updateCustomer(params).then(() => {
				this.getData()
				this.$refs.modalProfile.hideModal()
			})
		},
		async loginPOS(network_code) {
			await this.$refs.modalLoginPOS.showModal(network_code)
		},
		async resetPassword(customer_network_mid) {
			await this.$refs.modalResetPassword.showModal(customer_network_mid)
		},
		async ssoPOS(params) {
			let response = await this.loginSsoPOS(params)
			await this.$refs.modalLoginPOS.hideModal()
			window.open(response.url);
		},
		async updatePassword(params) {
			await this.$refs.modalResetPassword.hideModal()
			await this.$refs.resetPassword.showModal(params.customer_network_mid)
		},
		async updatePasswordConfirm(params) {
			this.isLoading = await true
			await this.updatePasswordCustomer(params)
			await this.getData()
			this.isLoading = await false
			await this.$refs.resetPassword.hideModal()
		},
		exportData() {
			this.exportCustomer(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		searchFilter(data) {
			this.params = data
			this.getData()
		},
		async onResetFilter() {
			let indexCity = this.filterData.findIndex(el => el.label == 'Kota')
			this.filterData[indexCity].item = []

			let indexDistrict = this.filterData.findIndex(el => el.label == 'Kecamatan')
			this.filterData[indexDistrict].item = []

			this.params = []
			this.getData()
		},
		async selectProvince(val) {
			this.filterData = [...this.filterParams]

			let indexCity = this.filterData.findIndex(el => el.label == 'Kota')
			this.filterData[indexCity].filter.value = ''

			this.filterData[indexCity].item = [allCity , ...await this.getOptionCity(val)]

			let indexDistrict = this.filterData.findIndex(el => el.label == 'Kecamatan')
			this.filterData[indexDistrict].filter.value = ''
			this.filterData[indexDistrict].item = [allSubdistrict]

			await this.setFilter(this.filterData)
		},
		async selectCity(val) {
			this.filterData = [...this.filterParams]

			let indexDistrict = this.filterData.findIndex(el => el.label == 'Kecamatan')
			this.filterData[indexDistrict].filter.value = ''
			this.filterData[indexDistrict].item = [allSubdistrict, ...await this.getOptionSubdistrict(val)]

			await this.setFilter(this.filterData)
		},
	},
	async created() {
		await this.$store.dispatch('setPageTitle', `Pelanggan`)
		await this.getData()

		let indexProvince = await this.filterData.findIndex(el => el.label == 'Provinsi')
		this.filterData[indexProvince].item = [allProvince, ...await this.getOptionProvince()]
		await this.setFilter(this.filterData)
	},
	beforeDestroy(){
		this.clearDataCustomer()
	},
	watch: {
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getData()
			}
		}
	}
};
</script>

<style>
tbody tr:nth-of-type(even) {
	background-color: rgba(0, 0, 0, .05);
}
.v-avatar .avatar {
	object-position: center;
	object-fit: cover;
}
</style>
